import { useAuth } from '~/lib/auth-context'
import { isTermsNotAccepted } from '~/lib/terms-acceptance'
import { trpc } from '~/utils/trpc'

/**
 * B-new-9684 — true when a SIGNED-IN user has not (provably) accepted the
 * current Terms. Surfaces that render on the terms exit routes
 * (`/dashboard/subscription`, `/withdrawal-rights`) while the acceptance gate
 * is bypassed use it to hide purchase paths and access claims: the header
 * credit button, Pricing links, the chatbot launcher.
 *
 * Fail closed for a signed-in user (loading, errored or malformed status all
 * count as "not accepted"); false for a signed-out visitor, who has nothing to
 * accept and must keep seeing the public chrome. Same query key as the
 * acceptance gate, so on gated routes the cached result is reused and nothing
 * extra is fetched.
 */
export function useTermsNotAccepted(): boolean {
  const { user, isLoading } = useAuth()
  const signedIn = !!user && !isLoading
  const status = trpc.user.getTermsStatus.useQuery(undefined, {
    enabled: signedIn,
    retry: 1,
    staleTime: 30_000,
  })
  if (!signedIn) return false
  return isTermsNotAccepted(status.data)
}
